import styled from "styled-components";
import { SectionText, MetaText } from "../atoms/Text";

const Wrapper = styled.section`
  background: #ffffff;
  padding: 16px;
`;

const HeaderRow = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
`;

const HeaderLeft = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  min-width: 0;
`;

const HeaderRight = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
`;

const Body = styled.div`
  margin-top: 12px;
`;

export function PageSection({ children }) {
  return (
    <Wrapper>
      <HeaderRow>
        <HeaderLeft>
          <SectionText>{children}</SectionText>
        </HeaderLeft>
      </HeaderRow>
    </Wrapper>
  )
}